import { Box, Button, Center, HStack, Text, VStack } from "native-base";
import React from "react";
import styled from "styled-components/native";

import BannerImage from "@/components/atoms/BannerImage";
import Breadcrumb from "@/components/atoms/Breadcrumb";
import RoundedLogo from "@/components/atoms/RoundedLogo";
import Container from "@/components/organisms/Container";
import WebHeader from "@/components/organisms/WebHeader";

import PromotionListItemLoading from "./components/PromotionListItemLoading";
import { PromotionListScreenProps } from "./types";

const PromotionListWeb = ({
  promotions,
  isLoading,
  onLoadMore,
  onGoBack,
  onSelectPromotion,
}: PromotionListScreenProps) => {
  return (
    <Container
      px="1/6"
      mb="32"
      Header={<WebHeader title="Promoções" badgeTitle="Corredores" onPressBack={onGoBack} />}>
      <Box pt="4">
        <Breadcrumb
          routes={[
            { title: "Home", routeName: "home" },
            { title: "Promoções", routeName: "promotions" },
          ]}
        />
      </Box>
      <Center py="8">
        <Text fontSize="3xl" color="text.600" bold>
          Promoções
        </Text>
      </Center>
      <VStack>
        <List>
          {isLoading &&
            new Array(9)
              .fill(null)
              .map((_, i) => <PromotionListItemLoading key={"PromotionListItemLoading" + i} />)}
          {promotions?.map((item, index) => (
            <VStack key={"PromotionListItem" + index} m="2" position="relative">
              <Text fontSize="lg" bold>
                {item.estabelecimento?.nome_fantasia}
              </Text>
              <HStack space={4} alignItems="center">
                <Box position="absolute" left={-10} zIndex={999}>
                  <RoundedLogo logoUrl={item.estabelecimento?.foto_estabelecimento} />
                </Box>
                <Box bgColor="light.50" shadow={4} rounded="lg">
                  <BannerImage
                    width="280px"
                    imageUrl={item.foto_promocao}
                    onPress={() => onSelectPromotion(item.estabelecimento._id)}
                  />
                </Box>
              </HStack>
            </VStack>
          ))}
        </List>
      </VStack>
      <Center my="8">
        <Button w="1/3" variant="outline" borderColor="primary.600" my="8" onPress={onLoadMore}>
          Ver mais
        </Button>
      </Center>
    </Container>
  );
};

const List = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`;

export default PromotionListWeb;
